export const EmptyReservationCardIcon = () => {
  return (
    <svg
      width="94"
      height="65"
      viewBox="0 0 94 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.220153"
        y="0.802184"
        width="93.5597"
        height="63.5597"
        rx="16.5115"
        stroke="#5D5D5D"
        strokeWidth="0.440306"
      />
      <path
        d="M55.5977 17.5908C59.2981 17.7786 62.2402 20.8389 62.2402 24.5859V36.0459L62.2314 36.4062C62.0501 39.9875 59.1788 42.8593 55.5977 43.041L55.2373 43.0498H41.8623L41.502 43.041C40.1462 42.9723 38.8926 42.5174 37.8477 41.7852L37.7969 41.835L37.5117 41.5332C35.9834 40.3199 34.9723 38.4831 34.8672 36.4062L34.8584 36.0459V24.5859C34.8584 20.8387 37.8013 17.7783 41.502 17.5908L41.8623 17.582H55.2373L55.5977 17.5908ZM39.2773 40.4346C40.0352 40.882 40.9185 41.1396 41.8623 41.1396H55.2373C58.0502 41.1394 60.3301 38.8589 60.3301 36.0459V24.5859C60.3301 23.4306 59.944 22.3663 59.2959 21.5117L39.2773 40.4346ZM41.8623 19.4922C39.0492 19.4922 36.7686 21.7728 36.7686 24.5859V36.0459C36.7686 37.2222 37.1682 38.3047 37.8379 39.167L57.874 20.2285C57.1748 19.8044 56.3657 19.543 55.499 19.499L55.2373 19.4922H41.8623Z"
        fill="black"
        fillOpacity={0.41}
      />
    </svg>
  );
};
